import { jsx as _jsx } from "react/jsx-runtime";
import { Select as AntdSelect } from "antd";
import cn from "classnames";
import "./Select.scss";
function SelectComponent(props) {
    return (_jsx(AntdSelect, Object.assign({}, props, { className: cn("te-select", props.className), popupClassName: cn("te-select-dropdown", props.popupClassName), children: props.children })));
}
export const Select = Object.assign(SelectComponent, {
    Option: AntdSelect.Option,
    OptGroup: AntdSelect.OptGroup
});
